import { Component, Input } from '@angular/core';
import { VoiceEmotion } from '@heygen/streaming-avatar';

import { TBotItem } from '@core/interfaces/TBotItem';

import { TalkingAvatarService } from '../../../../../../routes/bots/talking-avatar/talking-avatar.service';
import { CommonService } from '@shared/services/common.service';

import { CustomButtonComponent } from '../../message-controls/custom-button/custom-button.component';

@Component({
    selector: 'app-talking-avatar-toggle',
    templateUrl: './talking-avatar-toggle.component.html',
    styleUrls: ['./talking-avatar-toggle.component.scss'],
    standalone: true,
    imports: [CustomButtonComponent]
})
export class TalkingAvatarToggleComponent {
  @Input() bot: TBotItem | null = null;

  constructor(
    public talkingAvatarService: TalkingAvatarService,
    private _commonService: CommonService
  ) {}

  toggleAvatar(): void {
    if (this.talkingAvatarService.isClosed) {
      // Enable talking avatar for this chat - instant toggle
      this.talkingAvatarService.isClosed = false;

      // Set default config immediately so the window appears
      this.talkingAvatarService.config = {
        isAvailable: true,
        avatarId: 'Judy_Doctor_Sitting2_public',
        voiceRate: 1,
        voiceEmotion: VoiceEmotion.BROADCASTER,
      };

      // Show disclaimer about video saving
      this._commonService.openSnackBar(
        'Note: Please wait for the AI to finish speaking before the video can be saved.',
        'info',
        5000
      );

      // Set up the avatar and start automatic talking for active conversations
      const botToUse = this.bot || ({ _id: 'default', title: 'Default Avatar' } as any);
      this.talkingAvatarService
        .setSettings(botToUse)
        .then(() => {
          this.talkingAvatarService.handleTalking();
        })
        .catch(error => {
          console.error('Failed to setup talking avatar:', error);
          // Config is already set above, so avatar window will still show
        });
    } else {
      // Disable talking avatar for this chat - instant toggle
      this.talkingAvatarService.isClosed = true;
      this.talkingAvatarService.closeSession().catch(error => {
        console.error('Failed to close talking avatar session:', error);
      });
    }
  }

  getTooltipText(): string {
    const baseText = this.talkingAvatarService.isClosed
      ? 'Show Talking Avatar'
      : 'Hide Talking Avatar';

    // Add note about video controls and saving
    if (!this.talkingAvatarService.isClosed) {
      return `${baseText} (Use video controls to play/pause. Wait for AI to finish speaking before video can be saved)`;
    }

    return `${baseText} (Videos will be saved after AI finishes speaking)`;
  }
}
